import React, { Fragment, useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import { Button, Col, Row } from 'reactstrap';
import ModalUI from '../../../../shared/components/Modal';
import Spinner from 'react-bootstrap/Spinner';
import DataReactTableRetentionTypes from './DataReactTableRetentionTypes';


const AddRetentionType = ({setRetentionsTypeList}) => {
    const [loadTable, setLoadTable] = useState(false);
    const [listRetentionType, setListRetentionType] = useState(null);
    const [nameRetention, setNameRetention] = useState('');
    const [retentionTypeToUpdate, setRetentionTypeToUpdate] = useState(null);
    const [onEdit, setOnEdit] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        getRetentionsType();
    }, [])

    const validateForm = (values) => {
        const errors = {};
        if (!values.tipo_retencion) {
            errors.tipo_retencion = "Campo obligatorio";
        }

        console.log("ERRORSFORM", errors);
        return errors;
    }

    const getRetentionsType = async () => {
        setLoadTable(true);

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'tipo-retencion/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                console.log("TYPESRETENTIONS", data)
                setLoadTable(false);
                setListRetentionType(data);
                setRetentionsTypeList(data);
            })
            .catch((error) => {
                console.log(error)
            })
    };

    const saveRetentionsType = async () => {

        let dataSend = {
            tipo_retencion: nameRetention
        }

        let errors = validateForm(dataSend);
        setErrors(errors);

        if (Object.entries(errors).length === 0) {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'tipo-retencion/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then((response) => {
                    if (response.status != 500 && response.status != 403) {
                        return response.text();
                    }
                    else {
                        throw new Error(response.text());
                    }
                })
                .then((data) => {
                    setOpenAlert(true);
                    setModalAlert({
                        message: "Guardado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    });
                    setNameRetention('');
                    getRetentionsType();
                })
                .catch((error) => {
                    console.log(error)
                })
        }

    };

    const updateRetentionsType = async (id_retention) => {

        let dataSend = {
            tipo_retencion: nameRetention,
            id_tipo_retencion: id_retention
        }

        let errors = validateForm(dataSend);
        setErrors(errors);

        if (Object.entries(errors).length === 0) {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'tipo-retencion/update', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then((response) => {
                    if (response.status != 500 && response.status != 403) {
                        return response.text();
                    }
                    else {
                        throw new Error(response.text());
                    }
                })
                .then((data) => {
                    setOpenAlert(true);
                    setModalAlert({
                        message: "Actualizado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    });
                    setNameRetention('');
                    getRetentionsType();
                    setOnEdit(false);
                })
                .catch((error) => {
                    console.log(error)
                })
        }
        
    };

    const reactTableDataRetentionTypes = {
        tableHeaderData: [{
            Header: 'NOMBRE',
            accessor: 'tipo_retencion',
            disableGlobalFilter: true,
            width: 65
        },
        ],
        tableRowsData: listRetentionType
    };

    const onEditRetentionType = (retention) => {
        setOnEdit(true);
        setNameRetention(retention.tipo_retencion);
        setRetentionTypeToUpdate(retention)
    }

    const LoadInfo = () => {
        return (<DataReactTableRetentionTypes
            reactTableData={reactTableDataRetentionTypes}
            refresh={getRetentionsType}
            onEditRetentionType={onEditRetentionType}
        />)
    }

    return (
        <Fragment>
            <Row>
                <Col style={{marginLeft: '2em'}}>
                    <TextField
                        label="Nombre"
                        value={nameRetention}
                        onChange={(event) => {
                            setNameRetention(event.target.value)
                        }}
                        type="text"
                        className="medical-material-form__field"
                        style={{ width: '100%' }}
                        error={errors.hasOwnProperty("tipo_retencion") ? errors.tipo_retencion !== "" : false}
                        helperText={errors.tipo_retencion}
                    />
                </Col>
                <Col >
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <div>
                            <Button
                                size="sm"
                                style={{ marginLeft: 'auto', float: '' }}
                                color="primary"
                                onClick={() => {
                                    if (onEdit) {
                                        //updateRetentionsType(idTypeExpense);
                                        updateRetentionsType(parseInt(retentionTypeToUpdate.id_tipo_retencion))
                                    } else {
                                        saveRetentionsType();
                                    }
                                }}
                            >
                                {onEdit ? "Editar" : "Guardar"}
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    {
                        loadTable ?
                            <div className="text-center">
                                <Spinner animation="border" style={{ color: '#4ce1b6' }} />
                            </div>
                            : listRetentionType &&
                            <LoadInfo />
                    }
                </Col>
            </Row>

            {openAlert ?
                <ModalUI
                    color={modalAlert.color}
                    title={modalAlert.title}
                    message={modalAlert.message}
                    modal={openAlert}
                    toggle={() => { setOpenAlert(!openAlert) }}
                    onOk={() => { setOpenAlert(!openAlert) }}
                /> : null}
        </Fragment>
    )
}

export default AddRetentionType